// extracted by mini-css-extract-plugin
export default {"CardBody":"bVSwpwZ1smCW1F5rPJOJ"};